module.exports = __webpack_public_path__ + "media/nom-landing/nom-steps-3-deb54f76.png";